import { Stack } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import SelectExperiment from "../../base/SelectExperiment";
import { FlowNodeWithChildren } from "./FlowNode";

interface StartExperiment extends NodeData {
  experimentId: string;
}

const StartExperimentNode: React.FC<NodeProps<NodeType<StartExperiment>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const experimentId = nodeData?.experimentId ?? "";

  const { getValues, setValue, handleSubmit } = useForm<StartExperiment>({
    defaultValues: useMemo(
      () => ({experimentId}),
      [experimentId]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData<StartExperiment>(nodeId);

  const handleUpdate = useCallback(
    ({ experimentId }: StartExperiment) => {
      updateNodeData({experimentId});
    },
    [updateNodeData, setValue]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack>
          <SelectExperiment color={color} value={getValues("experimentId")} setValue={(value) => setValue("experimentId", value)} />
        </Stack>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(StartExperimentNode);
